const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 416,
    height: 415,
    viewBox: "0 0 416 415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5793"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4832",
    transform: "translate(.75)",
    style: {
      fill: "none"
    },
    d: "M0 0h415v415H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 31"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5792",
    transform: "translate(0 91.312)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5772"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21903",
    d: "M378.128 192.81c-6.039-8.28-4.9-20.25-2.995-28.88a82.57 82.57 0 0 0 4.212-38.83c-5.989-44.09-47.1-65-58.834-70.16-44.54-19.7-88.051-.33-98.542 4.34C169.2 82.78 79.666 201.78 0 217h316.179s91.515.83 99.441 1c-5.66-.48-26.452-10.09-37.492-25.19z",
    transform: "translate(0 -.74)",
    style: {
      fill: "#e7ebef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21904",
    d: "M416.37 217.92a2.44 2.44 0 0 0 .38 0z",
    transform: "translate(-.75 -.74)",
    style: {
      fill: "#e7ebef"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4833",
    transform: "translate(0 215.72)",
    style: {
      fill: "#d3d7df"
    },
    d: "M0 0h415.5v1.97H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5788",
    transform: "translate(65.601)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21905",
    d: "M307.58 216.27H65.89l39.83-46.83h156.1z",
    transform: "translate(-65.89 -.74)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4834",
    transform: "translate(94.73 160.82)",
    style: {
      fill: "#88909f"
    },
    d: "M0 0h52.21v14.88H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21906",
    d: "M228.13 192.86h-80.85l13.32-16.42h52.22z",
    transform: "translate(-65.89 -.74)",
    style: {
      fill: "#dce1e7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4835",
    width: 244.8,
    height: 161.71,
    rx: 11.79,
    transform: "translate(1.13)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21907",
    d: "M86.36 14.34H292.2A10.68 10.68 0 0 1 302.88 25v109.5H75.68V25a10.68 10.68 0 0 1 10.68-10.66z",
    transform: "translate(-65.89 -.74)",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4836",
    transform: "translate(9.93 131.22)",
    style: {
      fill: "#dce1e7"
    },
    d: "M0 0h227.19v10.58H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21908",
    d: "M292.34 14.34H86.5A10.68 10.68 0 0 0 75.82 25v6H303v-6a10.68 10.68 0 0 0-10.66-10.66z",
    transform: "translate(-65.89 -.74)",
    style: {
      fill: "#dce1e7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2562",
    cx: 4.18,
    cy: 4.18,
    r: 4.18,
    transform: "translate(16.2 18.47)",
    style: {
      strokeDasharray: "17.734 1.97 .985 4.926",
      strokeWidth: ".985px",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      stroke: "#88909f",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2563",
    cx: 4.18,
    cy: 4.18,
    r: 4.18,
    transform: "translate(28.72 18.47)",
    style: {
      strokeDasharray: "17.734 1.97 .985 4.926",
      strokeWidth: ".985px",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      stroke: "#88909f",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2564",
    cx: 4.18,
    cy: 4.18,
    r: 4.18,
    transform: "translate(41.38 18.47)",
    style: {
      strokeDasharray: "17.734 1.97 .985 4.926",
      strokeWidth: ".985px",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      stroke: "#88909f",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5776"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5775",
    transform: "translate(73.25 57.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4837",
    width: 43.62,
    height: 43.62,
    rx: 3.75,
    style: {
      strokeWidth: ".804px",
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21909",
    d: "M139.14 92.07v6.36a3.75 3.75 0 0 0 3.75 3.74H179a3.75 3.75 0 0 0 3.75-3.74v-6.36z",
    transform: "translate(-139.14 -58.55)",
    style: {
      strokeWidth: ".804px",
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5774"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5773"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4838",
    transform: "rotate(-40.18 21.752 -11.288)",
    style: {
      fill: "#88909f"
    },
    d: "M0 0h1.41v6.89H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4839",
    transform: "rotate(86.22 1.166 12.372)",
    style: {
      fill: "#88909f"
    },
    d: "M0 0h1.41v3.66H0z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21910",
    d: "m157.78 70.73-4.07 3.59a3.49 3.49 0 0 0-1.2 2.65v7.6a.83.83 0 0 0 .83.83h17V69.85h-10.2a3.55 3.55 0 0 0-2.36.88zm10.8 2.68h-11.52l1.06-1a3.39 3.39 0 0 1 2.32-.91h8.14z",
    transform: "translate(-139.14 -58.55)",
    style: {
      fill: "#88909f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21911",
    d: "M163.41 80.33a2 2 0 0 1-4 0c0-1.1.89-3.62 2-3.62s2 2.52 2 3.62z",
    transform: "translate(-139.14 -58.55)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 83",
    transform: "translate(80.66 93.8)",
    style: {
      strokeWidth: "1.478px",
      strokeDasharray: "17.734 1.97 .985 4.926",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      stroke: "#88909f",
      fill: "#fff"
    },
    d: "M0 0h30.05"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 84",
    transform: "translate(80.66 97.25)",
    style: {
      strokeWidth: "1.478px",
      strokeDasharray: "17.734 1.97 .985 4.926",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      stroke: "#88909f",
      fill: "#fff"
    },
    d: "M0 0h22.17"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5780"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5779",
    transform: "translate(21.38 57.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4840",
    width: 43.62,
    height: 43.62,
    rx: 3.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5778"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5777"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4841",
    transform: "rotate(-40.18 21.737 -11.295)",
    style: {
      fill: "#753bba"
    },
    d: "M0 0h1.41v6.89H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4842",
    transform: "rotate(86.22 1.17 12.37)",
    style: {
      fill: "#753bba"
    },
    d: "M0 0h1.41v3.66H0z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21912",
    d: "m105.91 70.73-4.07 3.59a3.53 3.53 0 0 0-1.2 2.65v7.6a.83.83 0 0 0 .83.83h17V69.85h-10.2a3.6 3.6 0 0 0-2.36.88zm10.81 2.68H105.2l1.06-1a3.35 3.35 0 0 1 2.31-.91h8.15z",
    transform: "translate(-87.27 -58.55)",
    style: {
      fill: "#753bba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21913",
    d: "M111.55 80.33a2 2 0 0 1-4 0c0-1.1.9-3.62 2-3.62s2 2.52 2 3.62z",
    transform: "translate(-87.27 -58.55)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4843",
    width: 43.62,
    height: 43.62,
    rx: 3.75,
    style: {
      strokeDasharray: "31.527 3.941",
      stroke: "#753bba",
      strokeWidth: ".985px",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 85",
    transform: "translate(28.44 93.8)",
    style: {
      stroke: "#753bba",
      strokeWidth: "1.478px",
      strokeDasharray: "17.734 1.97 .985 4.926",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      fill: "#fff"
    },
    d: "M0 0h30.05"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 86",
    transform: "translate(28.44 97.25)",
    style: {
      stroke: "#753bba",
      strokeWidth: "1.478px",
      strokeDasharray: "17.734 1.97 .985 4.926",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      fill: "#fff"
    },
    d: "M0 0h22.17"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5783",
    transform: "translate(177.68 57.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4844",
    width: 43.62,
    height: 43.62,
    rx: 3.75,
    style: {
      strokeWidth: ".804px",
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21914",
    d: "M243.57 92.07v6.36a3.75 3.75 0 0 0 3.75 3.74h36.12a3.75 3.75 0 0 0 3.75-3.74v-6.36z",
    transform: "translate(-243.57 -58.55)",
    style: {
      strokeWidth: ".804px",
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5782"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5781"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4845",
    transform: "rotate(-40.18 21.76 -11.29)",
    style: {
      fill: "#88909f"
    },
    d: "M0 0h1.41v6.89H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4846",
    transform: "rotate(86.22 1.171 12.378)",
    style: {
      fill: "#88909f"
    },
    d: "M0 0h1.41v3.66H0z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21915",
    d: "m262.21 70.73-4.07 3.59a3.53 3.53 0 0 0-1.2 2.65v7.6a.83.83 0 0 0 .83.83h17V69.85h-10.23a3.55 3.55 0 0 0-2.33.88zM273 73.41h-11.51l1.06-1a3.39 3.39 0 0 1 2.32-.91H273z",
    transform: "translate(-243.57 -58.55)",
    style: {
      fill: "#88909f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21916",
    d: "M267.85 80.33a2 2 0 0 1-4 0c0-1.1.9-3.62 2-3.62s2 2.52 2 3.62z",
    transform: "translate(-243.57 -58.55)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5787"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5786",
    transform: "translate(125.32 57.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4847",
    width: 43.62,
    height: 43.62,
    rx: 3.75,
    style: {
      strokeWidth: ".804px",
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21917",
    d: "M191.21 92.07v6.36a3.75 3.75 0 0 0 3.75 3.74h36.13a3.74 3.74 0 0 0 3.74-3.74v-6.36z",
    transform: "translate(-191.21 -58.55)",
    style: {
      strokeWidth: ".804px",
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5785"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5784"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4848",
    transform: "rotate(-40.18 21.754 -11.3)",
    style: {
      fill: "#88909f"
    },
    d: "M0 0h1.41v6.89H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4849",
    transform: "rotate(86.22 1.169 12.38)",
    style: {
      fill: "#88909f"
    },
    d: "M0 0h1.41v3.66H0z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21918",
    d: "m209.85 70.73-4.07 3.59a3.53 3.53 0 0 0-1.2 2.65v7.6a.83.83 0 0 0 .83.83h17V69.85h-10.2a3.6 3.6 0 0 0-2.36.88zm10.81 2.68h-11.52l1.06-1a3.35 3.35 0 0 1 2.31-.91h8.15z",
    transform: "translate(-191.21 -58.55)",
    style: {
      fill: "#88909f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21919",
    d: "M215.49 80.33a2 2 0 0 1-4 0c0-1.1.9-3.62 2-3.62s2 2.52 2 3.62z",
    transform: "translate(-191.21 -58.55)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 87",
    transform: "translate(132.38 93.8)",
    style: {
      strokeWidth: "1.478px",
      strokeDasharray: "17.734 1.97 .985 4.926",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      stroke: "#88909f",
      fill: "#fff"
    },
    d: "M0 0h30.05"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 88",
    transform: "translate(132.38 97.25)",
    style: {
      strokeWidth: "1.478px",
      strokeDasharray: "17.734 1.97 .985 4.926",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      stroke: "#88909f",
      fill: "#fff"
    },
    d: "M0 0h22.17"
  }))), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4850",
    width: 244.8,
    height: 161.71,
    rx: 11.79,
    transform: "translate(66.728)",
    style: {
      strokeDasharray: "49.261 1.97 1.97 3.941 11.823 .985",
      stroke: "#dce1e7",
      strokeWidth: "1.478px",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5789"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21920",
    d: "M75.15 77.15a4.48 4.48 0 0 1 1.42 2.49c.1 1.09-.48 1.81 0 2.83a2.22 2.22 0 0 1 .35 1.07c0 .47-.23.64-.35 1.06-.22.71.15 1.08.35 2.13a10.32 10.32 0 0 1 0 2.48 7.17 7.17 0 0 1-.35 2.48 14.139 14.139 0 0 0-.71 1.42c-.23.57-.31.93-.36 1.06-.67 1.85-11.23 1.71-12-1.42-.11-.39 0-.47 0-1.41a11.16 11.16 0 0 0-1.06-3.9 17.31 17.31 0 0 1-1.07-5c0-1.28-.19-4.52 2.13-6.73A7.83 7.83 0 0 1 69.83 74a8.75 8.75 0 0 1 5.32 3.15z",
    transform: "translate(0 -.74)",
    style: {
      fill: "#d2c0e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21921",
    d: "M95.18 94.35a8.69 8.69 0 0 1 2.13-4.26c1.23-1.58 1.58-1.3 3.19-3.19a10.2 10.2 0 0 0 2.66-4.43c.28-1.26 0-1.5.35-2.83a8.79 8.79 0 0 1 1.77-3.19c1.35-1.68 3.24-3.11 3.55-2.84s-.52 1.46-.71 1.77c-.88 1.45-1.93 2.26-1.77 2.48s.58-.23 1.06 0 .35.57.71 1.07c.53.73 1 .52 1.42 1.06.61.89-.14 2.39-.36 2.84a5.86 5.86 0 0 1-1.42 1.77c-.71.64-1 .59-1.41 1.06a4.74 4.74 0 0 0-1.07 2.49 22.689 22.689 0 0 1-1.77 3.85 50.577 50.577 0 0 1-2.84 4.61c-2.18 3.35-2.48 3.55-2.83 3.55-1.38.03-3-3.08-2.66-5.81z",
    transform: "translate(0 -.74)",
    style: {
      fill: "#d2c0e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21922",
    d: "M105.46 83.36c-2.28 1.59-2.42 4-3.9 7.44a24.53 24.53 0 0 1-5.27 8.2 2.14 2.14 0 0 0 1.55 1.16c.35 0 .65-.2 2.83-3.55a50.581 50.581 0 0 0 2.84-4.61 22.69 22.69 0 0 0 1.77-3.89 4.74 4.74 0 0 1 1.07-2.49c.46-.47.7-.42 1.41-1.06a5.86 5.86 0 0 0 1.42-1.77c.22-.45 1-2 .36-2.84-.38-.54-.89-.33-1.42-1.06-.36-.5-.33-.88-.71-1.07a.92.92 0 0 0-.51-.06 2 2 0 0 0-.73 1.3c0 .87 1 1.2 1.06 2.13S106 83 105.46 83.36z",
    transform: "translate(0 -.74)",
    style: {
      fill: "#b8a4d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21923",
    d: "M46.26 130.51c-.49.7-.42 1.45 0 3.9.58 3.49.87 5.23 1.41 7.45.95 3.88 1.35 4.79 1.6 6.91a17.8 17.8 0 0 0 .35 2.48c.35 1.48.75 2 .71 3.19 0 .89-.26.74-.35 1.77a8.38 8.38 0 0 0 .71 3.9 3.58 3.58 0 0 0 .71 1.42 3.12 3.12 0 0 0 3.54.36c2.14-1.51.54-7.61-.35-11-.37-1.38-.6-1.94-1.07-3.9a30.589 30.589 0 0 1-1.06-6c-.1-2.22.28-2.31.35-5.67.07-3 .09-4.55-.71-5.32-1.44-1.42-4.74-1.1-5.84.51z",
    transform: "translate(0 -.74)",
    style: {
      fill: "#d2c0e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21924",
    d: "M54.59 150.9c-.37-1.38-.6-1.94-1.07-3.9a30.59 30.59 0 0 1-1.06-6c-.1-2.22.28-2.31.35-5.67.07-3 .09-4.55-.71-5.32a2.71 2.71 0 0 0-.87-.56c-.39 2.38-.65 2.4-.72 4.64a46.54 46.54 0 0 0 1.06 10.28c.79 4.25 1.28 4.86 1.07 7.09s-.85 3.1-.71 5.32c.12 2.05.88 4.92 1.77 5 .73 0 1.5-1.85 2.2-4.58a47.151 47.151 0 0 0-1.31-6.3z",
    transform: "translate(0 -.74)",
    style: {
      fill: "#b8a4d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21925",
    d: "M79.93 228.36a6.93 6.93 0 0 0-.7 2.48 9.67 9.67 0 0 0 0 2.48 4 4 0 0 0 .35 1.77c.75 1 2.79.89 4.08.54 1.76-.49 1.57-1.26 3.9-2.13a7.41 7.41 0 0 0 2.44-1.06 4 4 0 0 0 1.42-2.13 4.29 4.29 0 0 0-.71-3.19 3.27 3.27 0 0 0-4.26-1.77c-3.61.83-5.55 1.27-6.52 3.01z",
    transform: "translate(0 -.74)",
    style: {
      fill: "#753bba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21926",
    d: "M51.93 226.94a5.33 5.33 0 0 0-1.42 2.48 3.17 3.17 0 0 0 0 2.13c.36.81.93.71 1.77 1.77s.49 1.24 1.07 1.77c.83.78 2 .75 3.19.71 1.36 0 2.94-.08 3.54-1.06.29-.46.08-.69 0-2.84v-2.83c0-2.77.21-2.85 0-3.19-1.02-1.62-5.85-1.29-8.15 1.06z",
    transform: "translate(0 -.74)",
    style: {
      fill: "#753bba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21927",
    d: "M55.12 147.88c-1.18 2.24-1.26 6.93-1.42 16.31-.05 2.78.1 5.1.13 5.58.05.81.13 1.65.22 2.57.71 6.66 2.15 10.21 1.25 13.66a10.41 10.41 0 0 0-.71 4.26 5.45 5.45 0 0 1 0 2.48 5.1 5.1 0 0 0-.36 2.48 7.56 7.56 0 0 1-.71 3.19c-.65 1.76.2 3.08.36 6 .13 2.63-.38 5.06-1.42 9.92a6.61 6.61 0 0 0 0 3.9c.32.88.67 1 .71 1.78.07 1.3-1 1.59-1.07 3.19a4.76 4.76 0 0 0 .36 2.13c.07.17.13.25.71 1.41.35.71.34.7.35.71.55.69 1.72.4 3.9.36s1.89.18 2.48 0c2-.62 3.38-3 2.84-4.26-.22-.49-.66-.58-.71-1.06-.07-.7.87-1.12 1.42-1.77.94-1.12.61-2.67.35-4.61a64.428 64.428 0 0 1-.35-7.45c0-1.18.24-3 .71-6.73s.73-4.91 1.06-8.16c.19-1.86.23-2.67.36-4.25.62-7.68 1.28-7.86 1.77-14.18a75.5 75.5 0 0 1 1.06-9.22c.2-.85.38-1.31.71-2.84s.44-2.46.71-2.48.62 1.09.71 1.42a53.93 53.93 0 0 1 1.77 13.12c-.06 5.57.88 3.58 1.78 14.89.39 5 .2 5.27.7 12.05.19 2.51.36 4.31.36 7.09 0 3.09-.2 3.14 0 4.61a28.92 28.92 0 0 0 2.13 7.09 9.19 9.19 0 0 1 1.06 3.55 20.382 20.382 0 0 0 0 2.48 4.33 4.33 0 0 0 .71 2.48c1.08 1.18 3.6.6 5 0 2.24-1 4.35-3.34 3.9-5-.23-.83-1-1.11-1.06-2.13a3.573 3.573 0 0 1 .71-1.77c1-2-.68-3.78-1.07-7.8a28.112 28.112 0 0 1 0-3.19 75 75 0 0 0-.71-8.51c-.63-5.38-.94-8.06-1.06-8.51-.53-2-1.39-4.46-.71-6.74.08-.26.37-1.14.71-2.12.55-1.58 1-2.71 1.06-2.84 1.22-3.06.71-11.7.71-11.7-.46-7.92 0-6.51-.71-16.66-.48-7.11-.69-7.61-1.06-8.16-4.76-6.84-25.01-5.37-29.64 3.43z",
    transform: "translate(0 -.74)",
    style: {
      fill: "#343a5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21928",
    d: "M49.45 102.15a7 7 0 0 0-1.45 3.19 25.31 25.31 0 0 0-.71 4.25c-.19 1.92-.21 2.68-.36 4.61-.19 2.61-.34 4.61-.7 7.09-.32 2.13-.71 4.26-.71 4.26-.64 3.45-1 4.4-.36 5.31s1.84 1.14 3.22 1.42 3.29.64 4.61-.35 1.17-2.86 1.42-6c.37-4.72 1.07-4.71 1.42-8.51.69-7.59-1.33-16.37-3.9-16.66-1.06-.15-2.27 1.15-2.48 1.39z",
    transform: "translate(0 -.74)",
    style: {
      fill: "#7b41cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21929",
    d: "M49.45 102.15a7 7 0 0 0-1.45 3.19 25.31 25.31 0 0 0-.71 4.25c-.19 1.92-.21 2.68-.36 4.61-.19 2.61-.34 4.61-.7 7.09-.32 2.13-.71 4.26-.71 4.26-.64 3.45-1 4.4-.36 5.31s1.84 1.14 3.22 1.42 3.29.64 4.61-.35 1.17-2.86 1.42-6c.37-4.72 1.07-4.71 1.42-8.51.69-7.59-1.33-16.37-3.9-16.66-1.06-.15-2.27 1.15-2.48 1.39z",
    transform: "translate(0 -.74)",
    style: {
      fill: "#7b41cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21930",
    d: "M54.41 125.9c.32-4.08.88-4.62 1.26-7.14-2.3-7.85-5.3-13.24-5.87-13.07s.31 4 .35 4.26a28.51 28.51 0 0 0 1.42 4.61c1.11 3.08.74 6.19 0 12.41a43.955 43.955 0 0 1-1 5.6 3.84 3.84 0 0 0 2.37-.64c1.4-1.01 1.22-2.86 1.47-6.03z",
    transform: "translate(0 -.74)",
    style: {
      opacity: 0.5,
      fill: "#343a5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21931",
    d: "M59.73 99.31c-.56-1.15.48-3.16 1.41-5a4.5 4.5 0 0 1 1.42-1.77 4.37 4.37 0 0 1 2.13-.71 21.2 21.2 0 0 1 7.09.35c1.89.49 2.94.78 3.55 1.77a3.46 3.46 0 0 1 .35 2.49c-1.08 4.24-14.47 5.93-15.95 2.87z",
    transform: "translate(0 -.74)",
    style: {
      fill: "#7b41cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21932",
    d: "M71.83 99.6c2-.75 3.51-1.82 3.85-3.12a3.46 3.46 0 0 0-.35-2.48c-.61-1-1.66-1.28-3.55-1.77l-.56-.12c1.12 1.88 2 4 1.27 6.15a5.3 5.3 0 0 1-.66 1.34z",
    transform: "translate(0 -.74)",
    style: {
      opacity: 0.5,
      fill: "#343a5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21933",
    d: "M62.92 90.8c.55.8 4.13 1.49 9.57-.35.67-2-.66-3.91-.35-5A4.15 4.15 0 0 1 73.55 83c.11-.07.92-.64 1.42-.35s.42.83.36 2.13c-.09 1.72-1.2 3.3-1.42 4.25-.76 3.19-1 3.86-.36 4.61a1.39 1.39 0 0 0 1.07.35 4.41 4.41 0 0 0 2.12-1.41c.76-1.18-.18-2.24-.35-3.19-.26-1.44-.6-1.31-.71-2.49s.29-1.13.35-3.19a5.57 5.57 0 0 1 .36-2.12 6.68 6.68 0 0 1 .35-.71c.62-1.32-.64-3.25-1.06-3.9a7.86 7.86 0 0 0-4.25-3.55 8.88 8.88 0 0 0-5.32.36 6.88 6.88 0 0 0-2.48 1.06 7.18 7.18 0 0 0-2.49 4.25 9.45 9.45 0 0 0 0 4.61A32.38 32.38 0 0 1 62.21 88c.29 1.76.28 2.19.71 2.8z",
    transform: "translate(0 -.74)",
    style: {
      fill: "#343a5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21934",
    d: "M50.51 101.09c.49-.88 1.63-1.31 3.9-2.13 1.15-.42 1.21-.36 2.13-.71a23.062 23.062 0 0 0 3.54-1.77 16.33 16.33 0 0 1 5.67-1.78 22.12 22.12 0 0 1 9.58 1.07 22.651 22.651 0 0 0 3.9 1.06 23.49 23.49 0 0 0 5.31 0c1.14-.09 5.71-2.33 7.09-3.19.19-.11 3.6-1.39 3.9-1.42a3.46 3.46 0 0 1 3.19 1.42 18.78 18.78 0 0 1 1.07 4.61c0 .86-1 1.26-2 2.3-1.16 1.21-.92 1.74-1.77 2.84-1.73 2.21-3.83 1.48-8.16 4.25a7.17 7.17 0 0 0-1.77 1.42c-1.36 1.64-1.32 3.59-1.42 5.32-.23 4.05-1 3.29-1.42 7.8-.31 3.44-.57 6.23.36 9.57.59 2.15 2.86 8.8 3.54 11.35a2.34 2.34 0 0 1 0 1.41c-.33 1-1.32 1.33-2.12 1.78-1.71.94-2.22 2-3.2 2.83-2.18 2-8 4.53-14.89 5-1.15.07-8.86.5-11.69-2.49a4.36 4.36 0 0 1-1.42-2.83 8.65 8.65 0 0 1 .71-2.48 8.79 8.79 0 0 0 0-3.9c-.42-3.18.16-6.39 1.06-11.35a15.31 15.31 0 0 0 .35-4.25 16.06 16.06 0 0 0-.7-3.55c-2.32-8.23-2.18-7-2.49-8.51-.51-2.62-.47-4.07-1.77-5.31-.65-.62-1.13-.71-1.42-1.42-.47-1.16.44-1.87.71-4.26.26-1.77-.18-1.95.23-2.68z",
    transform: "translate(0 -.74)",
    style: {
      fill: "#753bba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21935",
    d: "M87.2 143.1c-.68-2.55-3-9.2-3.54-11.35-.93-3.34-.67-6.13-.36-9.57.42-4.51 1.19-3.75 1.42-7.8.1-1.73.06-3.68 1.42-5.32a7.17 7.17 0 0 1 1.77-1.42c4.33-2.77 6.43-2 8.16-4.25.85-1.1.61-1.63 1.77-2.84 1-1 1.94-1.44 2-2.3a21 21 0 0 0-.52-2.93 16.71 16.71 0 0 1-5.15 5.41c-3.39 2.12-4.62.64-8.87 2.84-1.49.77-6 3.08-7.8 7.44-2.21 5.27 1.74 8 .71 16-.68 5.25-2.61 5.58-3.54 10.28a27 27 0 0 0 1.65 14.91 17.77 17.77 0 0 0 5.61-3c1-.88 1.49-1.89 3.2-2.83.8-.45 1.79-.83 2.12-1.78a2.34 2.34 0 0 0-.05-1.49z",
    transform: "translate(0 -.74)",
    style: {
      opacity: 0.5,
      fill: "#343a5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21936",
    d: "M60.08 234.74c.21-.33.16-.55.09-1.42-1.34.52-3.24 1.18-5.05.36a4 4 0 0 1-2.12-2.13 3.56 3.56 0 0 1 0-2.13 9.16 9.16 0 0 1 3.2-4.46 7.47 7.47 0 0 0-4.26 2 5.33 5.33 0 0 0-1.42 2.48 3.17 3.17 0 0 0 0 2.13c.36.81.93.71 1.77 1.77s.49 1.24 1.07 1.77c.83.78 2 .75 3.19.71 1.35-.06 2.93-.1 3.53-1.08z",
    transform: "translate(0 -.74)",
    style: {
      opacity: 0.5,
      fill: "#343a5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21937",
    d: "M89 225.35a3.82 3.82 0 0 0-2.48 0h-.08a10.34 10.34 0 0 0 2.39 2.29c1.06.71 1.06 2.84-2.13 3.9-1.85.62-1.2 1.53-2.13 2.13a5.92 5.92 0 0 1-3.9.71 5.229 5.229 0 0 1-1.35-.43 2.45 2.45 0 0 0 .29 1.13c.75 1 2.79.89 4.08.54 1.76-.49 1.57-1.26 3.9-2.13a7.41 7.41 0 0 0 2.41-1.05 4 4 0 0 0 1.42-2.13 4.29 4.29 0 0 0-.71-3.19 3.79 3.79 0 0 0-1.71-1.77z",
    transform: "translate(0 -.74)",
    style: {
      opacity: 0.5,
      fill: "#343a5c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5791",
    transform: "translate(288.9 97.33)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4851",
    width: 85.21,
    height: 95.65,
    rx: 6.7,
    transform: "translate(0 5.99)",
    style: {
      fill: "#eef2f5",
      strokeDasharray: "49.261 1.97 1.97 3.941 11.823 .985",
      strokeWidth: "1.478px",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2565",
    cx: 7.05,
    cy: 7.05,
    r: 7.05,
    transform: "translate(76.05)",
    style: {
      fill: "#b9bfcc"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5790"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4852",
    transform: "rotate(46.89 38.113 100.677)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h1.2v7.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4853",
    transform: "rotate(136.89 41.272 21.71)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h1.2v7.5H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 89",
    transform: "translate(305.65 156.11)",
    style: {
      strokeDasharray: "31.527 1.97 .985 4.926",
      strokeWidth: "1.478px",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      stroke: "#88909f",
      fill: "#fff"
    },
    d: "M0 0h49.26"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 90",
    transform: "translate(305.9 163.25)",
    style: {
      strokeDasharray: "31.527 1.97 .985 4.926",
      strokeWidth: "1.478px",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      stroke: "#88909f",
      fill: "#fff"
    },
    d: "M0 0h49.26"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4854",
    transform: "translate(305.41 174.09)",
    style: {
      strokeDasharray: "31.527 1.97 0 0",
      strokeWidth: "1.478px",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      stroke: "#88909f",
      fill: "#fff"
    },
    d: "M0 0h50.74v8.37H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21938",
    d: "M330.11 118.18a14.42 14.42 0 1 0 2.56 0 13.68 13.68 0 0 0-2.56 0zm9.05 11.09-8.52 8.43a1.38 1.38 0 0 1-1.91 0l-5-4.8a1.379 1.379 0 0 1 1.9-2l4.06 3.89 7.58-7.49a1.39 1.39 0 0 1 1.93 2z",
    transform: "translate(-.613 -.74)",
    style: {
      fill: "#88909f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 91",
    transform: "translate(250.004 93.8)",
    style: {
      strokeWidth: "1.478px",
      strokeDasharray: "17.734 1.97 .985 4.926",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      stroke: "#88909f",
      fill: "#fff"
    },
    d: "M0 0h30.05"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 92",
    transform: "translate(250.014 97.25)",
    style: {
      strokeWidth: "1.478px",
      strokeDasharray: "17.734 1.97 .985 4.926",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      stroke: "#88909f",
      fill: "#fff"
    },
    d: "M0 0h22.17"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracking);
export default __webpack_public_path__ + "static/media/tracking.5e034334dba25d8919b4fdc7f411c1fe.svg";
export { ForwardRef as ReactComponent };